import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { CenteredStoryText } from '@/components/microstory/text';
import { select, t, Trans } from '@lingui/macro';

export function TheOtherClimateCrisis2023Chapter2() {
  const answers = [
    {
      id: 'fifty',
      label: t({ id: `the-other-climate-crisis-2023.chapter-2.question.answer-1`, message: '50%' }),
    },
    {
      id: 'seventy',
      label: t({ id: `the-other-climate-crisis-2023.chapter-2.question.answer-2`, message: '70%' }),
    },
    {
      id: 'ninety',
      label: t({ id: `the-other-climate-crisis-2023.chapter-2.question.answer-3`, message: '90%' }),
    },
  ];

  const { selectedAnswer, handleAnswer } = useStoryQuestion<(typeof answers)[number]>();

  let response;
  if (selectedAnswer?.id) {
    response = t({
      id: `the-other-climate-crisis-2023.chapter-2.question.response`,
      message: select(selectedAnswer.id, {
        fifty: "That's right!",
        seventy: 'Afraid not!',
        ninety: 'Afraid not!',
      }),
    });
  }

  return (
    <>
      <StoryQuestion
        question={t({
          id: `the-other-climate-crisis-2023.chapter-2.question.question`,
          message:
            'We then asked young people who had heard of climate change to identify the correct definition of it between two options.',
        })}
        answerHeading={t({
          id: `the-other-climate-crisis-2023.chapter-2.question.answer-heading`,
          message: 'What share, on average, do you think got it right?',
        })}
        answers={answers}
        selectedAnswer={selectedAnswer}
        onAnswer={handleAnswer}
        response={response}
      />

      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-2.text-1`}>
          On average, only 50% chose the correct definition of climate change: a rise in average
          world temperatures and more extreme weather events resulting from human activities.
        </Trans>
      </CenteredStoryText>

      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-2.text-2`}>
          The remainder think climate change refers to seasonal changes in temperature.
        </Trans>
      </CenteredStoryText>
    </>
  );
}
